<template>
    <el-dialog :title="serial.name" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false">
        <el-form :model="serial" :rules="rules" ref="serialForm" label-width="100px">
            <el-form-item :label="$t('lang.smartlink.baudRate')" prop="baudrate">
                <el-select v-model="serial.baudrate" size="mini" :placeholder="$t('lang.DateSelect.PleaseChoose')">
                    <el-option label="9600" :value="i" :label="i" v-for="i in baudrateList" :key="i"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.smartlink.dataBits')" prop="data_bits">
                <el-select v-show="serial.data_bits !== undefined" @change="databitsChange" v-model="serial.data_bits"
                    size="mini" :placeholder="$t('lang.DateSelect.PleaseChoose')">
                    <el-option v-for="i in databitsList" :key="i" :label="i" :value="i"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.custom')" :value="undefined"></el-option>
                </el-select>
                <el-input ref="data_bits_custom" style="width: 190px;" :autofocus="true"
                    v-show="serial.data_bits === undefined" v-model="customValue" size="mini"
                    @blur="customInput"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.smartlink.stopBits')" prop="stop_bits">
                <el-select v-show="serial.stop_bits !== undefined" @change="stopbitsChange" v-model="serial.stop_bits"
                    size="mini" :placeholder="$t('lang.DateSelect.PleaseChoose')">
                    <el-option v-for="i in stopBitsList" :key="i" :label="i" :value="i"></el-option>
                    <el-option :label="$t('lang.ConfigSetting.custom')" :value="undefined"></el-option>
                </el-select>
                <el-input ref="stop_bits_custom" style="width: 190px;" :autofocus="true"
                    v-show="serial.stop_bits === undefined" v-model="customValue2" size="mini"
                    @blur="customInput2"></el-input>
            </el-form-item>
            <!-- 校验位 -->
            <el-form-item :label="$t('lang.smartlink.checkBits')" prop="parity">
                <el-select v-model="serial.parity" size="mini" :placeholder="$t('lang.DateSelect.PleaseChoose')">
                    <el-option v-for="i in parityList" :key="i.value" :label="i.label" :value="i.value"></el-option>
                </el-select>
            </el-form-item>
            <!-- 流控 -->
            <el-form-item :label="$t('lang.smartlink.flowControl')" prop="flow_ctrl">
                <el-select v-model="serial.flow_ctrl" size="mini" :placeholder="$t('lang.DateSelect.PleaseChoose')">
                    <el-option v-for="i in flow_ctrlList" :key="i.value" :label="i.label" :value="i.value"></el-option>
                </el-select>
            </el-form-item>
            <!-- 启用分包 -->
            <el-form-item :label="$t('lang.smartlink.enableSubcontracting')" prop="enable_frame">
                <el-switch v-model="serial.enable_frame" size="mini"></el-switch>
            </el-form-item>
            <!-- 分包间隔 -->
            <el-form-item :label="$t('lang.smartlink.subcontractingInterval')" prop="timeout">
                <el-input style="width: 190px;" v-model="serial.timeout" size="mini"></el-input>
            </el-form-item>
            <!-- 分包长度 -->
            <el-form-item :label="$t('lang.smartlink.subcontractingLength')" prop="frame_len">
                <el-input style="width: 190px;" v-model="serial.frame_len" size="mini"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="mini" @click="dialogVisible = false">{{$t('lang.switchCrad.Cancel')}}</el-button>
            <el-button size="mini" type="primary" @click="updateConfig">{{$t('lang.ConfigSetting.SaveApply')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { updateConfig } from "@/api/configurationlist";
export default {
    name: "",
    props: ['deviceSn', 'deviceDid'],
    data() {
        return {
            dialogVisible: false,
            serial: {

            },
            baudrateList: [
                '110',
                '134',
                '150',
                '200',
                '300',
                '600',
                '1200',
                '1800',
                '2400',
                '4800',
                '9600',
                '19200',
                '38400',
                '57600',
                '115200',
            ],
            customValue: "",
            customValue2: "",
            databitsList: [
                '6', '7', '8'
            ],
            stopBitsList: [
                '1', '2'
            ],
            rules: {},
            parityList: [
                {
                    label: 'None',
                    value: 'N'
                },
                {
                    label: 'Odd',
                    value: 'O'
                },
                {
                    label: 'Even',
                    value: 'E'
                },
                {
                    label: 'Mark',
                    value: 'M'
                },
                {
                    label: 'Space',
                    value: 'S'
                }
            ],
            flow_ctrlList: [
                {
                    label: 'None',
                    value: 'N'
                },
                {
                    label: 'Xon/Xoff',
                    value: 'X'
                },
            ]
        };
    },
    methods: {
        show(serial) {
            this.dialogVisible = true;
            this.serial = serial;
            console.log(this.serial);
        },
        confirmSerial() {

        },
        databitsChange() {
            this.customValue = this.serial.data_bits;
            this.$nextTick(() => {
                // data_bits_custom获得焦点
                this.$refs.data_bits_custom.focus();
            })
        },
        stopbitsChange() {
            this.customValue2 = this.serial.stop_bits;
            this.$nextTick(() => {
                // data_bits_custom获得焦点
                this.$refs.stop_bits_custom.focus();
            })
        },
        customInput() {
            this.databitsList.push(this.customValue)
            this.serial.data_bits = this.customValue
        },
        customInput2() {
            this.stopBitsList.push(this.customValue2)
            this.serial.data_bits = this.customValue2
        },
        updateConfig() {
            updateConfig(this.deviceSn, this.deviceDid, [
                {
                    config: 'smartele',
                    section: this.serial.name,
                    action: 0,
                    index: [0],
                    options: {
                        baudrate: this.serial.baudrate,
                        data_bits: this.serial.data_bits,
                        stop_bits: this.serial.stop_bits,
                        parity: this.serial.parity,
                        flow_ctrl: this.serial.flow_ctrl,
                        enable_frame: this.serial.enable_frame ? '1' : '0',
                        timeout: this.serial.timeout,
                        frame_len: this.serial.frame_len,
                    }
                }
            ]).then(res => {
                if (res.data.data.mess === 0) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.$emit('refresh');
                } else {
                    this.$message({
                        message: '保存失败',
                        type: 'error'
                    });
                }
            })
        }
    },
};
</script>
<style scoped></style>